// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2milp","inner":"Form_inner__1T9HT","range":"Form_range__1yab-","name":"Form_name___Zjnt","actions":"Form_actions__1REEG"};